export default __webpack_public_path__ + "e13419513b2c5a61ffed0b1ea310e12b.svg";